import React, { memo } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import bemit from 'Functions/bemit';
import { isTrue } from 'Shared/utilities';
const offline_steps = [{
  label: 'Pré-réservation',
  step: 0
}, {
  label: 'Validation et paiement',
  step: 2
}];
const steps_with_services = [{
  label: 'Lieu et espace',
  step: -1
}, {
  label: 'Services',
  step: 0
}, {
  label: 'Identification',
  step: 1
}, {
  label: 'Validation et paiement',
  step: 2
}];
const default_steps = [{
  label: 'Lieu et espace',
  step: -1
}, {
  label: 'Identification',
  step: 1
}, {
  label: 'Validation et paiement',
  step: 2
}];
export default memo(function BookingSteps({
  ...props
}) {
  const have_services = BookingFormStore.useState(s => isTrue(s.have_services));
  const completed = BookingFormStore.useState(s => isTrue(s.completed));
  const is__free = BookingFormStore.useState(s => s.grand_total > 0 === false);
  const step = BookingFormStore.useState(s => s.step);
  const steps_config = props.offline ? offline_steps : have_services ? steps_with_services : default_steps;
  const steps = steps_config.map(function (opt, index) {
    let is__active = opt.step == step;
    let is__past = opt.step < step;
    if (opt.step === 2 && props.paid === true) {
      is__active = false;
      is__past = true;
    }
    let label = is__free && opt.step === 2 ? 'Validation' : opt.label;
    const class_name = completed ? 'c-steps__step is-past' : 'c-steps__step' + (is__active ? ' is-active' : '') + (is__past ? ' is-past' : '');
    const output = /*#__PURE__*/React.createElement("li", {
      key: opt.label || opt.id,
      className: class_name,
      "data-step": String(index + 1)
    }, /*#__PURE__*/React.createElement("span", {
      className: "c-steps__step-label"
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "u-readers-only"
    }, "\xC9tape ", index + 1));
    return output;
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: bemit('c-steps', ['front-booking'])
  }, steps);
});
